import { SideMenuAlarm } from 'core/service/user-preferences/domain/model/side-menu-alarm.model';
import { useSideMenuAlarms } from 'core/custom-hooks/use-side-menu-alarms.hook';
import React, { createContext, useContext, useState } from 'react';
import { UserPreferencesProvider } from './user-preferences/providers/user-preferences.provider';

export type AppGlobalContextType = {
    isPageLoading: boolean;
    setIsPageLoading: React.Dispatch<React.SetStateAction<boolean>>;

    sideMenuAlarms: Record<string, SideMenuAlarm>;
};

export const AppGlobalContext = createContext<AppGlobalContextType>({
    isPageLoading: false,
    setIsPageLoading: () => {},

    sideMenuAlarms: {},
});

type AppGlobalProviderProps = React.PropsWithChildren;

export const AppGlobalProvider: React.FC<AppGlobalProviderProps> = ({ children }) => {
    const [isPageLoading, setIsPageLoading] = useState<boolean>(false);
    const { sideMenuAlarms } = useSideMenuAlarms();

    const contextValue = React.useMemo(
        () => ({
            isPageLoading,
            setIsPageLoading,
            sideMenuAlarms,
        }),
        [isPageLoading, sideMenuAlarms]
    );

    return (
        <AppGlobalContext.Provider value={contextValue}>
            <UserPreferencesProvider>{children}</UserPreferencesProvider>
        </AppGlobalContext.Provider>
    );
};

export const useAppContext = () => useContext<AppGlobalContextType>(AppGlobalContext);
